// utils/formUtils.js
export const clearExceptAccountNoFn = (setters) => {
  const { setAccountNo,
    setName, setAccountType, setPreviousBalance, setOpenDate, setMobile,
    setAgentName, setRecieved, setPresentBalance, setIsSave, setIsView, setFieldsLocked
  } = setters;
  setAccountNo("");
  setName("");
  setAccountType("");
  setPreviousBalance("");
  setOpenDate("");
  setMobile("");
  setAgentName("");
  setRecieved("");
  setPresentBalance("");
  setIsSave("false");
  setIsView("false");
  setFieldsLocked(false);
};

export const resetFormFn = (setAccountNo, clearFn) => {
  setAccountNo("");
  clearFn();
};
